import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    TrackingResponseError,
    TrackingStatusResponse,
    defaultStagesOrder,
    undeliveredStagesOrder,
    shortStagesOrder,
    PostCodeCheckResponse,
    initialStatusState
} from '../../Models';

export const statusSlice = createSlice({
    name: 'statuses',
    initialState: initialStatusState,
    reducers: {
        loadTrackingStatus: (state, _: PayloadAction<string>) => {
            // Intentionally left empty (e.g. for triggering saga)
        },
        loadTrackingStatusSuccess: (state, { payload }: PayloadAction<TrackingStatusResponse>) => {
            state.statuses = payload.statuses ?? [];
            state.carrier = payload.carrier ?? '';

            const latestStatus = payload.statuses?.[payload.statuses.length - 1];
            const productTypeCode = latestStatus?.productTypeCode ?? '';
            const statusCode = String(latestStatus?.statusCode ?? '');

            const isShortType = ['WA', 'ST', 'TRA'].includes(productTypeCode);
            const isNotFoundHint = String(statusCode) === 'NOT_FOUND_HINT';

            if (isNotFoundHint) {
                state.stages = []; // keine Stages anzeigen
            } else if (!payload.statuses?.length) {
                state.stages = undeliveredStagesOrder;
            } else if (isShortType) {
                state.stages = shortStagesOrder;
            } else {
                state.stages = defaultStagesOrder;
            }

            state.currentStatus = latestStatus ?? null;
            state.error = payload.error ?? {};
        },
        loadTrackingStatusFailed: (state, action: PayloadAction<TrackingResponseError>) => {
            return { ...initialStatusState, error: action.payload };
        },
        loadCheckPostCode: (state, _: PayloadAction<{ postCode: string; shipmentNumber: string }>) => {
            // intentionally left empty
        },
        checkPostCodeSuccess: (state, action: PayloadAction<PostCodeCheckResponse>) => {
            state.deliveredToDetails = action.payload;
        },
        checkPostCodeRejected: (state, action: PayloadAction<TrackingResponseError>) => {
            state.error = action.payload;
        },
        resetStatus: () => initialStatusState
    }
});

export const {
    loadTrackingStatus,
    loadTrackingStatusSuccess,
    loadTrackingStatusFailed,
    loadCheckPostCode,
    checkPostCodeSuccess,
    checkPostCodeRejected,
    resetStatus
} = statusSlice.actions;
